import tailwindConfig from '../tailwind.config';

//https://nuxt.com/docs/guide/directory-structure/app-config
export default defineAppConfig({
    extends: ['@nuxt-monorepo/base'],
    tailwindCss: {
        config: tailwindConfig,
    },
    // Use SVG mode for nuxt-icon so <NuxtIcon name="ri:..."> renders inline SVGs
    icon: {
        mode: 'css',
        cssLayer: 'base',
    },
});
